// third-party
import { FormattedMessage } from "react-intl";
import stickyNoteIcon from "../assets/icons/sticky-note-01.svg";

const icons = {
  veille: () => <img src={stickyNoteIcon} alt="expert icon" />,
};

const veille = {
  id: "veille",
  title: <FormattedMessage id="veille" />,
  type: "group",
  url: "/veille",
  icon: icons.veille,
};

export default veille;
